import React from 'react';
import { PRIVACY_EMAIL, openPreferences } from '../services/privacy';
import '../assets/css/Privacy.css';

export default function Privacy() {
  return <article className="privacy-page">
    <h1>Privacidade e seus dados</h1>
    <p className="privacy-intro">Esta página reúne orientações sobre o uso do Precificador da 61 Imóveis.
      Consulte também a <a href="https://www.61imoveis.com/politica-privacidade" target="_blank" rel="noreferrer">Política
      de Privacidade da empresa</a>.</p>

    <h2>Quais informações passam pelo sistema</h2>
    <p>As ferramentas de precificação usam características do imóvel, como bairro, área e quantidade de quartos.
      As áreas internas também trabalham com dados de usuários, clientes, visitas, propostas e documentos
      necessários às atividades imobiliárias. Informe somente os dados necessários à tarefa.</p>

    <h2>Armazenamento no navegador e estatísticas</h2>
    <p>O acesso pode permanecer salvo neste navegador por até sete dias. Use “Sair” ao terminar em um dispositivo
      compartilhado. A redefinição da senha pelo administrativo encerra as sessões anteriores. A preferência de
      estatísticas é guardada por até 180 dias. Se você autorizar, o Google Analytics será carregado na página
      inicial. Recusar não impede o uso do site. Sua escolha pode ser alterada quando quiser em{' '}
      <button type="button" className="privacy-inline" onClick={openPreferences}>Preferências de privacidade</button>.</p>
    <p>Ao recusar, interrompemos as estatísticas e removemos os cookies de Analytics acessíveis neste domínio.
      A retirada da autorização não apaga automaticamente informações já recebidas pelo Google.</p>

    <h2>Como solicitar informações ou exercer seus direitos</h2>
    <p>Você pode solicitar informações sobre o tratamento, acesso e correção dos seus dados,
      informações sobre compartilhamentos, revogação do consentimento e, quando aplicável,
      eliminação, bloqueio ou anonimização. Algumas informações podem precisar ser mantidas
      para cumprir obrigações legais.</p>
    <p>Entre em contato pelo atendimento geral da empresa e peça o encaminhamento ao responsável
      por privacidade: <a href={`mailto:${PRIVACY_EMAIL}?subject=Solicita%C3%A7%C3%A3o%20de%20privacidade`}>{PRIVACY_EMAIL}</a>.</p>
    <p>Descreva sua solicitação e um meio de retorno. Não envie senhas nem documentos pessoais
      completos no primeiro contato. A equipe poderá orientar a confirmação da sua identidade.</p>
  </article>;
}
